module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "subout.b7c56990.png";